import moment from "moment";
import { DateObject } from "react-multi-date-picker";

export const getFormatDates = (dates: DateObject[]): string[] => {
  return dates.map(date => moment(date.toDate()).format('YYYY-MM-DD[T]HH:mm:ss.SSS'))
}


export const getFormatToDate = (dates: string[]): DateObject[] => {
  return dates.map(date => (new DateObject(date)))
}